import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { DocumentEvent } from './document_events';

@Injectable({ providedIn: 'root' })
export class DocumentEventProvider extends DomainEventProvider<DocumentEvent> {}
